// 工具函数

/**
 * 转义HTML特殊字符，防止XSS
 */
export function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

/**
 * 生成唯一ID
 */
export function generateId(): string {
  return `floating-chat-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

/**
 * 注入CSS样式
 */
export function injectStyles(css: string, id: string): void {
  // 检查是否已存在
  if (document.getElementById(id)) {
    return;
  }

  const style = document.createElement('style');
  style.id = id;
  style.textContent = css;
  document.head.appendChild(style);
}

/**
 * 移除注入的样式
 */
export function removeStyles(id: string): void {
  const style = document.getElementById(id);
  if (style) {
    style.remove();
  }
}
